(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('changePasswordService', changePasswordService)

    changePasswordService.$inject = ['$http', 'CONFIG', 'messageService'];


    function changePasswordService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL +'/'+ CONFIG.API_CONFIG_GENERAL +'/'+ CONFIG.API + '/users';
        var service = {
            isCurrentPassword: isCurrentPassword,
            changePassword: changePassword,
            isSecurePassword: isSecurePassword
        };

        return service;

       function isCurrentPassword(currentPassword){
            return $http.get(urlBase + "/isCurrentPassword/" + currentPassword);
        }

        function changePassword(newPassword, oldPassword){
            return $http.put(urlBase + "/changePassword/" + newPassword + '/' + oldPassword)
                .then(function(res){
                    if(res.data) {
                        messageService.updateChangePassword();
                    }else{
                        messageService.registerUpdateError('');
                    }
                })
                .catch(function(){
                    messageService.registerUpdateError('');
                });
        }

        function isSecurePassword(newPassword){
            return $http.get(urlBase + "/isSecurePassword/" + newPassword);
        }
    }
})();
